export const LOGO = "https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";

export const USER_AVTER = "https://okneeraj.github.io/netflix-gpt//avatar-red.jpeg";
export const FETCH_ALL_MOVIE_DETAILS = process.env.REACT_APP_TMDB_BASE_URL;
export const VIDEO_API = process.env.REACT_APP_TMDB_BASE_URL;

export const API_OPTIONS = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${process.env.REACT_APP_TMDB_ACCESS_TOKEN}`
    }
  };

export const IMG_CDN_URL = process.env.REACT_APP_IMG_CDN_URL;
export const BG_CDN_URL = process.env.REACT_APP_BG_CDN_URL;
export const MAIN_BG_URL = process.env.REACT_APP_MAIN_BG_URL;

export const now_playing = "now_playing"
export const popular = "popular"
export const upcoming = "upcoming"
export const top_rated = "top_rated"





export const BACKGROUND_IMG = "https://assets.nflxext.com/ffe/siteui/vlv3/b4c7f092-0488-48b7-854d-ca055a84fb4f/5b22968d-b94f-44ec-bea3-45dcf457f29e/IN-en-20231204-popsignuptwoweeks-perspective_alpha_website_large.jpg"


